/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Meta_DescriptionInputs */

const en_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a new password for your Mark Egly Golf account.`)
};

const es_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establece una nueva contraseña para tu cuenta de Mark Egly Golf.`)
};

const de_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legen Sie ein neues Passwort für Ihr Mark Egly Golf-Konto fest.`)
};

const zh_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为你的 Mark Egly Golf 账户设置新密码。`)
};

const ar_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عيّن كلمة مرور جديدة لحسابك في Mark Egly Golf.`)
};

const fr_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définissez un nouveau mot de passe pour votre compte Mark Egly Golf.`)
};

const vi_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt mật khẩu mới cho tài khoản Mark Egly Golf của bạn.`)
};

const sw_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nenosiri jipya kwa akaunti yako ya Mark Egly Golf.`)
};

const th_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตั้งรหัสผ่านใหม่สำหรับบัญชี Mark Egly Golf ของคุณ`)
};

const bs_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postavite novu lozinku za svoj Mark Egly Golf račun.`)
};

const ja_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golfアカウントの新しいパスワードを設定します。`)
};

const ko_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf 계정의 새 비밀번호를 설정하세요.`)
};

const pt_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina uma nova senha para sua conta Mark Egly Golf.`)
};

const it_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta una nuova password per il tuo account Mark Egly Golf.`)
};

const sv_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange ett nytt lösenord för ditt Mark Egly Golf-konto.`)
};

const nl_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel een nieuw wachtwoord in voor je Mark Egly Golf-account.`)
};

const da_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sæt en ny adgangskode til din Mark Egly Golf-konto.`)
};

const nb_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg et nytt passord for Mark Egly Golf-kontoen din.`)
};

const fi_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aseta uusi salasana Mark Egly Golf -tilillesi.`)
};

const pl_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustaw nowe hasło dla konta Mark Egly Golf.`)
};

const ru_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установите новый пароль для своей учетной записи Mark Egly Golf.`)
};

const tr_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf hesabınız için yeni bir şifre ayarlayın.`)
};

const hi_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने Mark Egly Golf खाते के लिए एक नया पासवर्ड सेट करें।`)
};

const id_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur kata sandi baru untuk akun Mark Egly Golf Anda.`)
};

const ms_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapkan kata laluan baharu untuk akaun Mark Egly Golf anda.`)
};

const cs_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavte si nové heslo ke svému účtu Mark Egly Golf.`)
};

const el_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ορίστε νέο κωδικό πρόσβασης για τον λογαριασμό σας στο Mark Egly Golf.`)
};

const he_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הגדירו סיסמה חדשה לחשבון שלכם ב-Mark Egly Golf.`)
};

const af_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel 'n nuwe wagwoord vir jou Mark Egly Golf-rekening.`)
};

const hu_reset_meta_description = /** @type {(inputs: Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Állítson be új jelszót a Mark Egly Golf-fiókjához.`)
};

/**
* | output |
* | --- |
* | "Set a new password for your Mark Egly Golf account." |
*
* @param {Reset_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const reset_meta_description = /** @type {((inputs?: Reset_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reset_meta_description(inputs)
	if (locale === "de") return de_reset_meta_description(inputs)
	if (locale === "zh") return zh_reset_meta_description(inputs)
	if (locale === "ar") return ar_reset_meta_description(inputs)
	if (locale === "fr") return fr_reset_meta_description(inputs)
	if (locale === "vi") return vi_reset_meta_description(inputs)
	if (locale === "sw") return sw_reset_meta_description(inputs)
	if (locale === "th") return th_reset_meta_description(inputs)
	if (locale === "bs") return bs_reset_meta_description(inputs)
	if (locale === "ja") return ja_reset_meta_description(inputs)
	if (locale === "ko") return ko_reset_meta_description(inputs)
	if (locale === "pt") return pt_reset_meta_description(inputs)
	if (locale === "it") return it_reset_meta_description(inputs)
	if (locale === "sv") return sv_reset_meta_description(inputs)
	if (locale === "nl") return nl_reset_meta_description(inputs)
	if (locale === "da") return da_reset_meta_description(inputs)
	if (locale === "nb") return nb_reset_meta_description(inputs)
	if (locale === "fi") return fi_reset_meta_description(inputs)
	if (locale === "pl") return pl_reset_meta_description(inputs)
	if (locale === "ru") return ru_reset_meta_description(inputs)
	if (locale === "tr") return tr_reset_meta_description(inputs)
	if (locale === "hi") return hi_reset_meta_description(inputs)
	if (locale === "id") return id_reset_meta_description(inputs)
	if (locale === "ms") return ms_reset_meta_description(inputs)
	if (locale === "cs") return cs_reset_meta_description(inputs)
	if (locale === "el") return el_reset_meta_description(inputs)
	if (locale === "he") return he_reset_meta_description(inputs)
	if (locale === "af") return af_reset_meta_description(inputs)
	if (locale === "hu") return hu_reset_meta_description(inputs)
	return en_reset_meta_description(inputs)
});